import React, { useState } from 'react';
import { CodeScanner } from './CodeScanner';
import { useAuth } from '../contexts/AuthContext';
import ModalCloseButton from './ModalCloseButton';
import '../styles/components/qrAssignModal.css';

interface QRAssignModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedItemIds: number[];
  onAssign: (qrCode: string, itemIds: number[]) => Promise<void>;
  onShowToast?: (message: string) => void;
}

export const QRAssignModal: React.FC<QRAssignModalProps> = ({
  isOpen,
  onClose,
  selectedItemIds,
  onAssign,
  onShowToast
}) => {
  const { token } = useAuth();
  const [isAssigning, setIsAssigning] = useState(false);

  if (!isOpen) return null;

  const handleQRScanned = async (location: { area: string; location: string; sub_location: string }) => {
    const qrCode = location.sub_location;
    
    if (!qrCode) {
      alert('No QR code detected');
      return;
    }

    setIsAssigning(true);
    try {
      await onAssign(qrCode, selectedItemIds);
      onClose();
      // Show toast after modal closes
      if (onShowToast) {
        setTimeout(() => {
          onShowToast(`✅ Assigned ${selectedItemIds.length} item${selectedItemIds.length > 1 ? 's' : ''} to QR code`);
        }, 100);
      }
    } catch (error) {
      console.error('[QRAssignModal] Failed to assign QR:', error);
      alert('Failed to assign QR code to items');
    } finally {
      setIsAssigning(false);
    }
  };

  return (
    <div className="qr-assign-modal-overlay" onClick={onClose}>
      <div className="qr-assign-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="qr-assign-modal-header">
          <h2>Assign QR Code to Items</h2>
          <ModalCloseButton onClick={onClose} />
        </div>

        <div className="qr-assign-modal-body">
          <p className="qr-assign-info">
            Scan a QR code to assign it as the sub-location for {selectedItemIds.length} selected item{selectedItemIds.length > 1 ? 's' : ''}.
          </p>

          <div className="scanner-container">
            <CodeScanner
              token={token || ''}
              onLocationScanned={handleQRScanned}
            />
          </div>

          {isAssigning && (
            <div className="assigning-indicator">
              <div className="spinner"></div>
              <p>Assigning QR code...</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
